export default __webpack_public_path__ + "static/sponsor-5be927e443f7b06cc3f0919a933e9a95.png";